import { combineReducers } from 'redux';
import HeaderConfig from './HeaderConfigs'; //配置文件名称变成大写
import commonReducer from "@/reducers/Common";

export default combineReducers({
  HeaderConfig,
  common: commonReducer
});
